export function getPostponedLetterRequestsPath() {
  return '/anwaltsschreiben'
}
